(function () {
  function initFerrerHeader(root) {
    if (!root || root.dataset.ferrerHeaderInit === "true") return;
    root.dataset.ferrerHeaderInit = "true";

    var header = root.querySelector("[data-ferrer-header]");
    var toggle = root.querySelector("[data-ferrer-nav-toggle]");
    var overlay = root.querySelector("[data-ferrer-nav-overlay]");
    var panel = root.querySelector("[data-ferrer-nav-panel]");
    if (!header || !toggle || !overlay || !panel) return;

    function onScroll() {
      header.classList.toggle("is-scrolled", window.scrollY > 8);
    }

    function unlockScroll() {
      document.body.classList.remove("nav-open");
    }

    function closeNav() {
      panel.classList.remove("is-open");
      overlay.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      panel.setAttribute("aria-hidden", "true");
      unlockScroll();
    }

    function openNav() {
      panel.classList.add("is-open");
      overlay.classList.add("is-open");
      toggle.setAttribute("aria-expanded", "true");
      panel.setAttribute("aria-hidden", "false");
      document.body.classList.add("nav-open");
    }

    function toggleNav() {
      if (panel.classList.contains("is-open")) closeNav();
      else openNav();
    }

    function onKeydown(event) {
      if (event.key === "Escape") closeNav();
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("keydown", onKeydown);
    toggle.addEventListener("click", toggleNav);
    overlay.addEventListener("click", closeNav);

    panel.querySelectorAll("a").forEach(function (link) {
      link.addEventListener("click", closeNav);
    });

    onScroll();
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".ferrer-storefront").forEach(initFerrerHeader);
  });

  document.addEventListener("shopify:section:load", function (event) {
    var root = event.target.querySelector(".ferrer-storefront");
    if (root) initFerrerHeader(root);
  });
})();

/* Announcement bar rotation */
(function () {
  function initAnnouncement(bar) {
    if (!bar || bar.dataset.ferrerAnnInit === "true") return;
    bar.dataset.ferrerAnnInit = "true";
    var items = bar.querySelectorAll("[data-announcement-item]");
    if (items.length < 2 || bar.getAttribute("data-rotate") !== "true") return;
    var interval = parseInt(bar.getAttribute("data-interval"), 10) || 4000;
    var current = 0;
    setInterval(function () {
      items[current].classList.remove("is-active");
      current = (current + 1) % items.length;
      items[current].classList.add("is-active");
    }, interval);
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-ferrer-announcement]").forEach(initAnnouncement);
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();

/* Countdown timers */
(function () {
  function pad(n) {
    return (n < 10 ? "0" : "") + n;
  }

  function initCountdown(el) {
    if (!el || el.dataset.ferrerCountdownInit === "true") return;
    el.dataset.ferrerCountdownInit = "true";
    var target = new Date(el.getAttribute("data-ferrer-countdown")).getTime();
    if (isNaN(target)) return;
    var clock = el.querySelector("[data-countdown-clock]");
    if (!clock) return;

    function tick() {
      var diff = target - Date.now();
      if (diff <= 0) {
        clock.textContent = "00:00:00";
        clearInterval(timer);
        return;
      }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      clock.textContent = (days > 0 ? days + "d " : "") + pad(hours) + ":" + pad(mins) + ":" + pad(secs);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-ferrer-countdown]").forEach(initCountdown);
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();

/* Collapsible rich text (Ler mais / menos) */
(function () {
  function initCollapsible(toggle) {
    if (!toggle || toggle.dataset.ferrerCollapsibleInit === "true") return;
    toggle.dataset.ferrerCollapsibleInit = "true";
    var wrap = toggle.closest(".rich-text");
    var body = wrap && wrap.querySelector("[data-ferrer-collapsible]");
    if (!body) return;
    toggle.addEventListener("click", function () {
      var expanded = body.classList.toggle("is-expanded");
      toggle.textContent = expanded
        ? toggle.getAttribute("data-less")
        : toggle.getAttribute("data-more");
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-ferrer-collapsible-toggle]").forEach(initCollapsible);
  }

  document.addEventListener("DOMContentLoaded", function () {
    boot(document);
  });
  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
